import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_ENDPOINT

const login = (identifier, password) => {
    return axios
        .post(API_URL + "/api/auth/local", {
            identifier,
            password,
        })
        .then((response) => {
            console.log(response)
            if (response.data.jwt) {
                localStorage.setItem("token", JSON.stringify(response.data.jwt));
            }

            return response.data;
        });
};

const userInfo = ({ token }) => {
    return axios.get(`${API_URL}/api/users/me`, {
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: {
            populate: '*'
        }
    }).then((response) => {
        if (response.data) {
            localStorage.setItem("user", JSON.stringify(response.data));
        }
        return response.data
    })
}

const logout = () => {
    localStorage.removeItem("user");
};

const authService = {
    // register,
    login,
    logout,
    userInfo
};

export default authService;